import type { ControllerType, LoadType } from "./electricalTypesEnum";

export interface ElectricalSlots {
  readonly controllers: ControllerTypeSlots;
  readonly loads: LoadTypeSlots;
}

export interface ControllerTypeSlots {
  readonly primary: ControllerType;
  readonly secondary?: ControllerType;
  readonly tertiary?: ControllerType;
  readonly quaternary?: ControllerType;

  readonly sensor: ControllerType;
}

export interface LoadTypeSlots {
  // used for situations where upgrades exist for some builders and not others
  // e.g. primary - surface ceiling light, secondary - recessed ceiling light
  // if secondary does not exist, shifts to the primary

  readonly primaryLight: LoadType;
  readonly secondaryLight?: LoadType;
  readonly tertiaryLight?: LoadType;
  readonly quaternaryLight?: LoadType;

  readonly outlet: LoadType;
  readonly outletGFCI: LoadType;
  readonly outletGFCIwaterProof: LoadType;
  readonly outletFloor: LoadType;
  readonly cableOutlet: LoadType;
  readonly outlet240V: LoadType;
  readonly outlet220V: LoadType;
  readonly outletHDMI: LoadType;
  readonly outletCAT5: LoadType;

  readonly recessedCeilingLight: LoadType;
  readonly pendantCeilingLight: LoadType;
  readonly keylessCeilingLight: LoadType;
  readonly flourescentCeilingLight: LoadType;
  readonly trackCeilingLight: LoadType;
  readonly mountedWallLight: LoadType;
  readonly floodLight: LoadType;

  readonly fanCeiling: LoadType;

  readonly smokeDetector: LoadType;
  readonly carbonMonoxideDetector: LoadType;
  readonly thermostat: LoadType;
  readonly bathFan: LoadType;

  readonly garageDoorOpener: LoadType;
  readonly dishDisposal: LoadType;

  readonly doorbellChime: LoadType;

  readonly hoseBib: LoadType;
}

export enum ControllerTypeSlot {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TERTIARY = "TERTIARY",
  QUATERNARY = "QUATERNARY",
}

export enum LoadTypeSlot {
  PRIMARY_LIGHT = "PRIMARY_LIGHT",
  SECONDARY_LIGHT = "SECONDARY_LIGHT",
  TERTIARY_LIGHT = "TERTIARY_LIGHT",
  QUATERNARY_LIGHT = "QUATERNARY_LIGHT",

  OUTLET = "OUTLET",
  OUTLET_GFCI = "OUTLET_GFCI",
  OUTLET_GFCI_WP = "OUTLET_GFCI_WP",
  OUTLET_FLOOR = "OUTLET_FLOOR",
  OUTLET_240V = "OUTLET_240V",
  OUTLET_220V = "OUTLET_220V",
  OUTLET_CAT5 = "OUTLET_CAT5",
  CABLE_OUTLET = "CABLE_OUTLET",
  OUTLET_HDMI = "OUTLET_HDMI",

  RECESSED_CEILING_LIGHT = "RECESSED_CEILING_LIGHT",
  PENDANT_CEILING_LIGHT = "PENDANT_CEILING_LIGHT",
  KEYLESS_CEILING_LIGHT = "KEYLESS_CEILING_LIGHT",
  FLOURESCENT_CEILING_LIGHT = "FLOURESCENT_CEILING_LIGHT",
  TRACK_CEILING_LIGHT = "TRACK_CEILING_LIGHT",
  MOUNTED_WALL_LIGHT = "MOUNTED_WALL_LIGHT",
  FLOOD_LIGHT = "FLOOD_LIGHT",

  SMOKE_DETECTOR = "SMOKE_DETECTOR",
  CARBON_MONOXIDE_DETECTOR = "CARBON_MONOXIDE_DETECTOR",
  THERMOSTAT = "THERMOSTAT",
  DOORBELL_CHIME = "DOORBELL_CHIME",
  DISH_DISPOSAL = "DISH_DISPOSAL",
  GARAGE_DOOR_OPENER = "GARAGE_DOOR_OPENER",

  FAN_CEILING = "FAN_CEILING",
  BATH_FAN = "BATH_FAN",

  HOSE_BIB = "HOSE_BIB",
}
